import { render, staticRenderFns } from "./order-dialog.vue?vue&type=template&id=cf38a10a&scoped=true&"
import script from "./order-dialog.vue?vue&type=script&lang=js&"
export * from "./order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./order-dialog.vue?vue&type=style&index=0&id=cf38a10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf38a10a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
